import loadable from '@loadable/component';
import React, { useRef } from 'react';
import { compose } from '@/utils/story-composer';

const Plyr = loadable(() => import('plyr-react'), {
	ssr: true,
});

export function EmbeddedVideo({ videoId = '', videoPlatform = 'youtube' }) {
	const videoRef = useRef();

	return (
		<div className="rounded-lg overflow-hidden ">
			<Plyr
				preload="none"
				ref={videoRef}
				source={{
					type: 'video',
					sources: [{ src: videoId, provider: videoPlatform }],
				}}
				options={{ hideControls: true }}
			/>
		</div>
	);
}

compose('embedded-video', EmbeddedVideo);
export default EmbeddedVideo;
